export default function shortName (value) {
	if (value && value !== null && value !== '') {
		if (value.length > 2) {
			var pos = value.indexOf(' ');
			if (pos > -1 && (pos + 2 < value.length)) {
				return (value.substr(0, 1) + value.substr(pos + 1, 1));
			} else {
				return value.substr(0, 2);
			}
		} else {
			return value;
		}
	} else {
		return '--';
	}
}



// WEBPACK FOOTER //
// ./src/filters/shortName.js